export const ClipboardItem = window.ClipboardItem